import { render, staticRenderFns } from "./RoomExtras.vue?vue&type=template&id=01b5bb1e&"
import script from "./RoomExtras.vue?vue&type=script&lang=js&"
export * from "./RoomExtras.vue?vue&type=script&lang=js&"
import style0 from "./RoomExtras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomExtras.vue"
export default component.exports